<div *ngIf="hasSos && !sos.respondido" class="sos-cdc-cp">
    <a (click)="toggleOn = !toggleOn" class="sos-bar">
        <span class="icon sos-icon"></span>
        <h3>SOS</h3>
        <span class="sos-subtitle"> Pendências impedindo conclusão da análise</span>
    </a>
    <div *ngIf="toggleOn">
        <div class="col-xs-12">
            <div class="form-group">
                <app-observacao [sos]="sos" [local]="local"></app-observacao>
                <app-documentos *ngIf="hasDocumentos()" [sos]="sos" [proposta]="proposta"></app-documentos>

                <div class="sos-content">
                    <button class="btn btn-border-orange" title="Enviar SOS" (click)="sendSos()">Responder SOS</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="hasSos && sos.respondido">
    <div class="sos-cdc-cp attended">
        <a class="sos-bar">
            <span class="icon sos-icon"></span>
            <h3>SOS Atendido</h3>
            <div *ngIf="hasDocumentos()">
                <span class="sos-subtitle">- Inclusão de Imagens </span>
            </div>

            <div *ngIf="hasObservacao()">
                <span class="sos-subtitle">- Informações do cliente </span>
            </div>
        </a>
    </div>
</div>
